<div class="dashboard_card-box mb-3">
    <h3 class="title-text">Summary</h3>
    <ul class="list-value" [ngClass]="{'list-grid' : isSidePanel}">
        <li>
            <div class="list-value_box">
                <strong>{{(summary?.bbPercent || 0 ) | number : '1.2-2'}}%</strong>
                <span class="value-text">Buy Box Winning</span>
            </div>
        </li>
        <li>
            <div class="list-value_box">
                <strong>{{(summary?.sales || 0) | currency}}</strong>
                <span class="value-text">Sales</span>
            </div>
        </li>
        <li>
            <div class="list-value_box">
                <strong>{{(summary?.competitions || 0)}}</strong>
                <span class="value-text">Competition</span>
            </div>
        </li>
        <li>
            <div class="list-value_box">
                <strong>{{(summary?.repriceActivity || 0)}}%</strong>
                <span class="value-text">Repricer Activity</span>
            </div>
        </li>
    </ul>
</div>
<div class="row" [ngClass]="{'chart-grid' : isSidePanel}">
    <div class="col-md-6" [ngClass]="{'col-md-12' : isSidePanel}">
        <div class="dashboard_card-box graph" [ngClass]="{'mb-3' : isSidePanel}">
            <div class="d-flex justify-content-between mb-3">
                <span class="title-text">Buy Box Winning</span>
                <app-date-component-renderer  [currentDateFilter]="currentDateFilter" [winningBuyBox]="true" [priceyardDashboard]="true"></app-date-component-renderer>
            </div> 
            <div *ngIf="buyBoxWinningData && !buyBoxWinningLoading" id="{{'buyBoxWinning' + id}}" style="height: 210px; width: 100%;">
                <app-bar-chart  [id]="'buyBoxWinning' + id" [data]="buyBoxWinningData" [chartColors]="buyBoxWinningChartColors" [labels]="buyBoxWinninglabels" [yAxisLabelType]="'percentage'"></app-bar-chart>
            </div> 
            <div  class="loader" *ngIf="buyBoxWinningLoading" style="height: 210px;">
                <img  src="assets/images/nineyard-loading.gif" >
            </div>          
        </div>
    </div>
    <div class="col-md-6" [ngClass]="{'col-md-12' : isSidePanel}">
        <div class="dashboard_card-box graph" [ngClass]="{'mb-3' : isSidePanel}">
            <div class="d-flex justify-content-between mb-3">
                <span class="title-text">Sales</span>
                <app-date-component-renderer  [currentDateFilter]="currentDateFilter" [isSales]="true" [priceyardDashboard]="true"></app-date-component-renderer>
            </div> 
            <div id="{{'sales' + id}}" *ngIf="salesData && !salesDataLoading" style="height: 210px; width: 100%;">
                <app-bar-chart  [id]="'sales' + id" [data]="salesData" [chartColors]="salesChartColors" [labels]="saleslabels" [yAxisLabelType]="'dollar'"></app-bar-chart>
            </div>
            <div  class="loader" *ngIf="salesDataLoading
            " style="height: 210px;">
                <img  src="assets/images/nineyard-loading.gif" >
            </div>  
        </div>
    </div>
    <div class="col-md-6" [ngClass]="{'col-md-12' : isSidePanel}">
        <div class="dashboard_card-box graph" [ngClass]="{'mb-3' : isSidePanel}">
            <div class="d-flex justify-content-between mb-3">
                <span class="title-text">Competition</span>
                <app-date-component-renderer  [currentDateFilter]="currentDateFilter" [competition]="true" [priceyardDashboard]="true"></app-date-component-renderer>
            </div> 
            <div id="{{'competition' + id}}" *ngIf="competitionData && !competitionDataLoading" style="height: 210px; width: 100%;">
                <app-bar-chart  [id]="'competition' + id" [data]="competitionData" [chartColors]="competitionChartColors" [labels]="competitionlabels"></app-bar-chart>
            </div>
            <div  class="loader" *ngIf="competitionDataLoading" style="height: 210px;">
                <img  src="assets/images/nineyard-loading.gif" >
            </div>   
        </div>
    </div>
    <div class="col-md-6" [ngClass]="{'col-md-12' : isSidePanel}">
        <div class="dashboard_card-box graph">
            <div class="d-flex justify-content-between mb-3">
                <span class="title-text">Repricer Activity</span>
                <app-date-component-renderer  [currentDateFilter]="currentDateFilter" [repriceActivity]="true" [priceyardDashboard]="true"></app-date-component-renderer>
            </div> 
            <div id="{{'repriceActivity' + id}}" *ngIf="repriceActivityData && !repriceActivityLoading" style="height: 210px; width: 100%;">
                <app-lines-chart [id]="'repriceActivity' + id" [data]="repriceActivityData" [chartColors]="repriceActivityChartColors" [labels]="repriceActivitylabels" [yAxisLabelType]="'percentage'"></app-lines-chart>
            </div> 
            <div  class="loader" *ngIf="repriceActivityLoading" style="height: 210px;">
                <img  src="assets/images/nineyard-loading.gif" >
            </div>  
        </div>
    </div>
</div>